module.exports = __webpack_public_path__ + "img/strategy.363ff947.svg";